import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-esg-01.jpg";
import esg01 from "../../assets/img/esg-01.jpg";
import esg02 from "../../assets/img/esg-02.jpg";
import esg03 from "../../assets/img/esg-03.jpg";

function VisionObjective() {
	// 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    return (
        <>
		<main className="page-wrapper">
			{isAdmin ? <AdminHeader /> : <Header />}
			
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>ESG</h2>
						<p>위피아는 지속가능한 경영을 위해 사회적 역할과 책임을 다하고 신뢰받는 기업이 되기 위해 노력합니다.</p>
					</div>
					<SubMenu />
			</section>
			
			{/* ESG 비전 및 목표 */}
			<section className="esg-visoinObj">
				<div className="container-auto sec-mt title-box">
					<h3 className="sub-title">ESG 비전 및 목표</h3>
					<p className="sub-text">위피아는 급변하는 경영환경 속에서도 사회적 역할과 책임을 다하여 새로운 가치를 창출하고 지속가능한 기업으로 발전시켜나가기 위한 노력을 아끼지 않겠습니다.</p>
				</div>

				<div className="bg-blue sec-py">
					<div className="container-auto">
						<h4 className="esg-list-tit">지속 가능한 소프트웨어를 개발하여 사회적 가치 창출  </h4>

						<ul className="w-list">
							<li><p>안전한 근무환경 조성 및 지역사회 기여를 통한 <span className="bold blue">사회적 책임성 강화</span></p></li>
							<li><p><span className="bold blue">온실가스 감축</span> 목표 달성</p></li>
							<li><p>투명하고 공정한 경영을 통한 <span className="bold blue">청렴한 기업문화</span> 정착</p></li>
						</ul>
					</div>
				
				
				
				
				
				
				
				
				
				
				</div>

			</section>

			{/* 추진전략 */}
			<section className="container-auto sec-my">
				<h3 className="sub-title">추진전략</h3>

				<ul className="esg-strategy">
					<li>
						<img src={esg01} className="list-img" />
						<div className="textBox">
							<span>친환경 경영</span>
							<h5>Environmental</h5>
							<p>위피아는 전사 환경 방침 및 실무 추진 조직을 구성함과 동시에 환경 영향을 최소화하기 위해 에너지 절감 활동과 온실가스 감축을 위한 다회용 개인컵 사용 등 임직원들이 참여하는 친환경 캠페인을 시행하고 있습니다.</p>
						</div>
					</li>
					<li>
						<img src={esg02} className="list-img" />
						<div className="textBox">
							<span>사회</span>
							<h5>Social</h5>
							<p>위피아는 기업의 경영할동 과정에서 직.간접적으로 일어날 수 있는 모든 인권 침해를 예방하고 관련리스크를 완화하기 위해 인권경영체계를 구축하였으며, 안전한 근무환경 조성을 위해 안전 대응 체계를 구축하여 운영하고 있습니다.</p>
							<p>그리고 기업 이해관계자들의 자유와 권리를 보호하고 나아가 개인의 존엄과 가치를 실현하기 위해 개인정보보호 정책을 실행하고 있습니다. 또한 사회적 책임을 다하는 기업시민으로서의 역할 수행을 위해 지역 밀착형 사회공헌 활동을 개발하는 등 지속가능한 사회공헌 체계 구축에 힘쓰고 있습니다.</p>
						</div>
					</li>
					<li>
						<img src={esg03} className="list-img" />
						<div className="textBox">
							<span>지배구조</span>
							<h5>Governance</h5>
							<p>위피아는 투명하고 공정한 경영 활동을 통해 청렴한 기업문화를 정착하고, 다양한 이해관계자로부터 신뢰와 존경을 받는 기업이 되기 위해 윤리경영 체계를 구축하여 운영하고 있습니다.</p>
						</div>
					</li>
				</ul>	
			</section>
		</main>
	<Footer />
        </>
    )
}

export default VisionObjective;